import { render, staticRenderFns } from "./TarifaPeaje.vue?vue&type=template&id=5bf0a233&"
import script from "./TarifaPeaje.vue?vue&type=script&lang=js&"
export * from "./TarifaPeaje.vue?vue&type=script&lang=js&"
import style0 from "./TarifaPeaje.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports